// extracted by mini-css-extract-plugin
export default {"folder":"Navigation_folder__3yqJI","foldericon":"Navigation_foldericon__7c5wk","graphicon":"Navigation_graphicon__sQBv7","navbody":"Navigation_navbody__DJwrq"};